'use strict';

import angular from 'angular';
import FormCtrl from './static/form.controller.js';
import FormDirective from './dynamic/form.directive.js';
import DbErrorDirective from './database-error.directive.js';

export default angular.module('georgeApp.formCtrl', [])
  .directive('gtForm', FormDirective)
  .directive('databaseError', DbErrorDirective)
  .controller('FormCtrl', FormCtrl)
  .name;
